// extracted by mini-css-extract-plugin
module.exports = {"background":"background--1RegC","leftNav":"leftNav--ha-Oq","rightNav":"rightNav--2P6Q9","topNav":"topNav--1LYLq","username":"username--DDYZG"};